import { useTranslation } from 'react-i18next';

import { capitalizeFirstLetter } from 'themes/helpers/capitalizeFirstLetter';

import { Icon } from 'components/Icon';

import * as S from './Error.styles';

type ErrorProps = {
  /** i18n keys describing each missing required field. Translated for display. */
  missingFields?: string[];
};

export function Error({ missingFields = [] }: ErrorProps): React.ReactElement {
  const { t } = useTranslation();
  const translated = missingFields.map((k) =>
    capitalizeFirstLetter(String(t(k as Parameters<typeof t>[0])))
  );

  return (
    <S.Container>
      <Icon name="FiXCircle" color="#a94442" />

      <S.Info scale="s" fontFamily="LFT Zeno" color="dangerRed">
        {translated.length > 0
          ? `${t('form.someFieldsMissing')}: ${translated.join(', ')}.`
          : t('form.errorFields')}
      </S.Info>
    </S.Container>
  );
}
